import { render } from "./PrivacyComponent.vue?vue&type=template&id=0508f27a&scoped=true"
import script from "./PrivacyComponent.vue?vue&type=script&lang=js"
export * from "./PrivacyComponent.vue?vue&type=script&lang=js"

import "./PrivacyComponent.vue?vue&type=style&index=0&id=0508f27a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0508f27a"]])

export default __exports__